import io from "socket.io-client";
import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Button, Form, ListGroup } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { RoomContext } from "../App";
import { NicknameContext } from "../App";
import { socket } from "../App";
import "../index.css";
import { signOut } from "firebase/auth";

import { auth, provider } from "../firebase";
import { signInWithPopup } from "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";
import {collection} from "firebase/firestore"


import { InputGroup } from "react-bootstrap";
import { Game } from "./game";
import { RoomMenu } from "./roommenu";
import { Lobby } from "./lobby";
import { Card } from "react-bootstrap";
import previewGif from "../gamePreview.gif";
import { Image } from "react-bootstrap";

import  pinkPenguin from "../pinkPenguin.webp";
import sketchPenguin from "../penguin-drawing.jpg"
import pinkCloud from "../pinkCloud.png"
import {UserContext} from "../App"
import {db} from "../firebase"
import { doc, getDoc, addDoc, getDocs, updateDoc } from "firebase/firestore";
import {query,where} from "firebase/firestore"




export const Main = () => {
  const [roomInput, setRoomInput] = useState("");
  const [roomExists, setRoomExists] = useState(false);
  const [nickname, setNickname] = useState("");
  const [nicknameExists, setNicknameExists] = useState(false);
  const [players, setPlayers] = useState([]);
  const [inRoom, setInRoom] = useState(false);
  const [ready, setReady] = useState(false);
  const { room, setRoom } = useContext(RoomContext);
  const { nickname_GLOBAL, setNickname_GLOBAL } = useContext(NicknameContext);

  const [displayBetaInput, setDisplayBetaInput] = useState(false);
  
 // const [user] = useAuthState(auth);

  const {user, setUser} = useContext(UserContext);



  useEffect(() => {
   // console.log("n", nickname_GLOBAL);
  }, [nickname_GLOBAL]);

  const handleReady = () => {
    setReady(true);
  //  console.log(room, nickname_GLOBAL);
    socket.emit("ready", {
      room: room,
      nickname: user?.displayName,
    });
  };

  const navigate = useNavigate();
  const [isHost, setIsHost] = useState(false);

  const [gameStarted, setGameStarted] = useState(false);

  useEffect(() => {
    if (user && user.displayName) {
   //   console.log("UPDATE", user.displayName);
      setNickname_GLOBAL(user?.displayName);
    }
  }, [user]);

  useEffect(() => {
   // console.log(user);
   // console.log(user?.displayName);
    socket.on("room_res", (res) => {
      //  console.log("E",res);
   //   console.log(res);
      setPlayers(res.players);
    });

    socket.on("game_starts", async () => {
      // navigate("/game");
    //  console.log(user)
   //   console.log(localStorage.getItem("user"))
   console.log(user)
      if (!user) {
        return
      }


      const q = query(collection(db,"users"), where("name", "==" , user.email))
      const querySnapshot = await getDocs(q);

      const limit = querySnapshot.docs[0].data().limit
      await updateDoc(doc(db, "users", querySnapshot.docs[0].id), {
        limit: limit - 1
      })

      setGameStarted(true);
    });

  //  console.log(players);
  //  console.log(auth)

  //  console.log(players);
    return () => {
      socket.off("room_res");
      socket.off("game_starts");
    };
  
  }, []);

  useEffect(() => {
  //  console.log(players);
  }, [players]);

  useEffect(() => {
 //   console.log(auth)
  }, [auth])

  const joinWithNickname = (nickname) => {
    // console.log(roomInput, nickname);
    socket.emit(
      "join_room",
      { room: roomInput, nickname: nickname_GLOBAL },
      (response) => {
        //   console.log(roomInput, nickname, response);
        if (response.status === "success") {
          //    console.log(response.message);
          setInRoom(true);
          setRoom(roomInput);
      //    console.log(user);
       //   console.log("UPDATE2", nickname, user?.displayName);

          setNickname_GLOBAL(user.displayName);
          // handle success, navigate to the room or update the UI
        } else {
        //  console.error(response.message);
          // handle error, show an error message to the user
        }
      }
    );
  };

  const joinRoom = () => {
    socket.emit("room_exists", roomInput, (response) => {
      if (response.status === "success") {
        //    console.log(response.message);
        joinWithNickname(nickname);
      } else {
        //   console.error(response.message);
        // handle error
      }
    });
  };

  const [loggedInWithGoogle, setLoggedInWithGoogle] = useState(false);

  const signInWithGoogle = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      
      console.log(result.user.email)
      const q = query(collection(db,"users"), where("name", "==" , result.user.email))
      const querySnapshot = await getDocs(q);
    //  console.log(querySnapshot)

      setLoggedInWithGoogle(true);
      console.log(querySnapshot)

      if (querySnapshot.docs.length === 0) {
   
        const doc2ref = await addDoc(collection(db,"users"), {
          name: result.user.email,
          limit: 10
        })
    //    console.log(doc2ref)
    setNickname_GLOBAL(result.user.email);

      } else {
    //    console.log("exists")
       console.log(querySnapshot.docs[0].data())
        if (false && querySnapshot.docs[0].data().limit <= 0) {
          
    //      alert(`You have reached your limit of 10 games. 
  //        If you actually like the game, contact me eero.the.engineer@gmail.com and I'll give you more.`)
          signUserOut();
          setUser(null)
          setNickname_GLOBAL("");
          setOpenForm("");
          return;
        }
        setNickname_GLOBAL(result.user.email);
      }

      console.log(nickname_GLOBAL);
      setUser({displayName: auth.currentUser.displayName,
      email: auth.currentUser.email,
    })
   //   console.log(result);
      setNickname_GLOBAL(auth.currentUser.displayName);
    } catch (e) {
 //     console.error(e);
    }
  };

  const signUserOut = async () => {
   // console.log("sign out", inRoom, user, room);
    if (inRoom) {
      socket.emit("disconnect_", { room: room, nickname: user?.displayName });
      setInRoom(false);
      setGameStarted(false);
      setRoom("");
      setIsHost(false);
     
    }
    setLoggedInWithGoogle(false)
    setUser(null)
    setNickname_GLOBAL("");
    setOpenForm("");
    await signOut(auth);
  };

  let handleJoinRoomClick;
  let FaArrowRight;
  const [joinRoomVisible, setJoinRoomVisible] = useState(false);
  const [openForm, setOpenForm] = useState("");

  const handleBetaKey = async (e) => {
    e.preventDefault();

    const key = e.target[0].value;

    const q = query(collection(db,"users"), where("name", "==" , key))
    const querySnapshot = await getDocs(q);
   // console.log(querySnapshot)

    if (querySnapshot.docs.length === 0) {
 
      const doc2ref = await addDoc(collection(db,"users"), {
        name: key,
        limit: 10
      })
   //   console.log(doc2ref)

    } else {
    //  console.log("exists")
  //    console.log(querySnapshot.docs[0].data())
      if (querySnapshot.docs[0].data().limit === 0) {
     //   alert(`You have reached your limit of 10 games. 
   //     If you actually like the game, contact me eero.the.engineer@gmail.com and I'll give you more.`)
        signUserOut();
        setUser(null)
        setNickname_GLOBAL("");
        setOpenForm("");
        return;
      }
    }

    socket.emit("check_beta_key", {key:key}, (res) => {
      if (res.status === "success") {
     //   console.log(res.message);
        setDisplayBetaInput(false)
        setNickname_GLOBAL("beta");
        setUser({displayName: key,email: key})
      } else {
     //   setDisplayBetaInput(false)
    //    setNickname_GLOBAL("beta");
     //   setUser({displayName: key,email: key})

    alert("Invalid key, contact eero.the.engineer@gmail.com for one (you'll get one guaranteed)")
      }
    })
  }

  return (
    <Container className="mt-5">
      <Row>
        <Col xs={12} md={8} lg={6}>
          <h1
            className=" mb-4 mt-4"
            style={{ textAlign: "left", cursor: "pointer" }}
            onClick={() => navigate("/")}
          >
            Photofusion <span style={{ fontSize: "0.5em" }}>beta</span>
          </h1>

          {nickname_GLOBAL ? (
            <div style={{ textAlign: "left", marginBottom: "15px" }}>
              logged in @{user?.displayName}
              <p
                style={{ textDecoration: "underline", cursor: "pointer" }}
                onClick={() => navigate("/profile")}
              >
                saved images
              </p>
              <p
                style={{ textDecoration: "underline", cursor: "pointer" }}
                onClick={signUserOut}
              >
                log out
              </p>
            </div>
          ) : (
            <>
            <Button
              style={{
                textAlign: "left",
                whiteSpace: "nowrap",
                marginRight: "100%",
                marginBottom: "15px",
              }}
              variant="light"
              onClick={() => alert(`I've disabled the photofusion server for now. \n\nWhy? Because I'm making a new app :) \n\ncontact: eero.the.engineer@gmail.com`)}
            >
              sign in with google{" "}
            </Button>
            <div style={{textAlign:"left"}}>OR</div>
            <Button onClick={() => alert(`I've disabled the photofusion server for now. \n\nWhy? Because I'm making a new app :) \n\ncontact: eero.the.engineer@gmail.com`)}
                          style={{
                            textAlign: "left",
                            whiteSpace: "nowrap",
                            marginRight: "100%",
                            marginBottom: "15px",
                          }}
                          variant="light">
              enter a beta key
            </Button>
            {displayBetaInput && (
              <Form onSubmit={handleBetaKey}>
                      <Form.Group className="mb-3">
      
        <Form.Control type="text" placeholder="Enter key" />
      </Form.Group>
      <Button variant="light" type="submit" >Submit</Button>
              </Form>
            )}
            </>
          )}

          {!inRoom ? (
            <RoomMenu
              setInRoom={setInRoom}
              setRoom={setRoom}
              setIsHost={setIsHost}
              loggedInWithGoogle={loggedInWithGoogle}
            />
          ) : gameStarted ? (
            <Game
              setInRoom={setInRoom}
              setRoom={setRoom}
              setGameStarted={setGameStarted}
            />
          ) : (
            <Lobby room={room} players={players} isHost={isHost} />
          )}

          {!gameStarted && (
            <>
          <h3 style={{marginTop: "50px",textAlign:"left"}}>How to play</h3>
          <div style={{textAlign:"left"}}>In multiplayer mode, each player uploads a single image and the images are then fused together for a funny/surprising/cool
            result</div>
            <div style={{textAlign:"left"}} className="mt-3">In the <strong>Fusion Tool</strong>, you can fuse together multiple images yourself</div>
            </>
            
          )}
           <h3 style={{marginTop: "50px",textAlign:"left"}}>Examples</h3>
           <Row>

           <div style={{textAlign:"left"}} className="mt-3">Create new characters:</div>
           <Image fluid src="https://media.discordapp.net/attachments/1023199844082397234/1179440966952812674/hulker.png?ex=6579caff&is=656755ff&hm=183dfd830b82e452b89585b90d9cf7e2674d7f59bcc9a16e3ff17e41125d9f73&=&format=webp&quality=lossless&width=1125&height=633"
           />
           <Image fluid className="mt-3"
             src="https://media.discordapp.net/attachments/1023199844082397234/1178433822413570078/fast.png?ex=65762105&is=6563ac05&hm=6ab87a07e3b61d8dc6d141413c8614d48f64b8f81779ce4e23bb6cd57da9fbad&=&format=webp&width=1125&height=633">
              
             </Image>
            <Image src="https://media.discordapp.net/attachments/1023199844082397234/1179439526721097748/snoralxXmuk.png?ex=6579c9a8&is=656754a8&hm=da0accb47778b4d15b30a1137fbbd1d43fb8a40d1d1ca405f309bace8261fe0a&=&format=webp&quality=lossless&width=1125&height=633"
             fluid/>
            
            <Image src="https://media.discordapp.net/attachments/1023199844082397234/1179440236837732472/legoAstro1.png?ex=6579ca51&is=65675551&hm=a4f16df940c642563306aec0c262fc675d748b5f6d40497bfe9a29f306be9f99&=&format=webp&quality=lossless&width=1437&height=412"
            fluid/>

            <Image src="https://media.discordapp.net/attachments/1023199844082397234/1179439480638275705/animeBlack.png?ex=6579c99d&is=6567549d&hm=888c8c66596e35df78b7ffea000601c0841b6a61a9b2b75bb67a3e2a8dde4482&=&format=webp&quality=lossless&width=1125&height=633"
            fluid />

            <Image src="https://media.discordapp.net/attachments/1023199844082397234/1179439527190876170/blitzBatman.png?ex=6579c9a8&is=656754a8&hm=1e067a13416568e33db87e71eaea53641a503094590e68eb89acea037d7319fd&=&format=webp&quality=lossless&width=1125&height=633"
            fluid />
     
            <Image src="https://media.discordapp.net/attachments/1023199844082397234/1178102070176399451/example1.png?ex=6574ec0d&is=6562770d&hm=981c6cb180a6ad598ba57edbd7688f07e92754388776f3eb7f61b55f8a20f9a8&=&format=webp&width=1125&height=520"
             fluid/>

<Image src="https://media.discordapp.net/attachments/1023199844082397234/1179439526721097748/snoralxXmuk.png?ex=6579c9a8&is=656754a8&hm=da0accb47778b4d15b30a1137fbbd1d43fb8a40d1d1ca405f309bace8261fe0a&=&format=webp&quality=lossless&width=1125&height=633"
             fluid/>

             <Image fluid className="mt-3"
             src="https://media.discordapp.net/attachments/1023199844082397234/1178436286068035604/fast21.png?ex=65762350&is=6563ae50&hm=38a972989039ae01cdaba1517af73ddf28ce212274f53cb5238dfe680e3ea568&=&format=webp&width=1125&height=633"
             ></Image>

 


             <div style={{textAlign:"left"}} className="mt-3">With memes:</div>
             <Image src="https://media.discordapp.net/attachments/1023199844082397234/1178103867519537282/example3.png?ex=6574edba&is=656278ba&hm=84bfb51b68adb6eabae8c1b13804b33d0d8618423d53c35cbb48d1d5c3bd84d6&=&format=webp&width=1125&height=520"
             fluid/>

<div style={{textAlign:"left"}} className="mt-3">Augment drawings:</div>
             <Image src="https://media.discordapp.net/attachments/1023199844082397234/1178103078260592713/example2.png?ex=6574ecfd&is=656277fd&hm=c3e746990dbcc849ed3f91281bb9f1e9aa3abcbc04305ae6a402a4f85647dcff&=&format=webp&width=1125&height=520"
             fluid/>



      </Row>

  {/*}        <h3 style={{marginTop: "50px",textAlign:"left"}}>How to play</h3>
          <p style={{textAlign:"left"}}>Splasher is a game where you can create 
          funny images by mixing photos together. You can play with your friends
          by creating a room and inviting them to join.</p>
  <Container className="mt-4">
      <Row className="mt-2">
        <Col>
          <h5 style={{textAlign:"left"}}>1. Upload an Image:</h5>
          <p style={{textAlign:"left"}}>
          Every player contributes by uploading an image from their camera roll.
          </p>
        </Col>
      </Row>
      <Row className="mt-1">
        <Col>
          <h5 style={{textAlign:"left"}}>2. Witness the Result:</h5>
          <p style={{textAlign:"left"}}>See the unexpected unfold as the images collide, 
          taking styles from each and crafting a surprising and imaginative result.</p>
        </Col>
      </Row>

    </Container>*/}
        </Col>
      </Row>
      {/*}
      <footer style={{ marginTop: '2rem', backgroundColor: '#f8f9fa', padding: '1rem 0' }}>
      <Container>
        <Row>
          <Col className="text-center">
            <p>Feedback: eero.the.engineer@gmail.com</p>
          </Col>
        </Row>
      </Container>
          </footer> */}
    </Container>
  );
};

/*
         <Card className="shadow">
            <Card.Body>
              <Card.Title className="text-center mb-4">Cartooner</Card.Title>
              <Form>
                <Form.Group controlId="room">
                  <Form.Control
                    type="text"
                    placeholder="Enter room number"
                    value={roomInput}
                    onChange={(e) => setRoomInput(e.target.value)}
                  />
                </Form.Group>
                <Button variant="light" block onClick={joinRoom}>
                  Join Room
                </Button>
                {roomExists && (
                  <Form.Group controlId="nickname" className="mt-3">
                    <Form.Control
                      type="text"
                      placeholder="Enter nickname"
                      value={nickname}
                      onChange={(e) => setNickname(e.target.value)}
                    />
                    <Button variant="primary" block className="mt-2" onClick={joinWithNickname}>
                      Join
                    </Button>
                    {nicknameExists && <p className="text-danger mt-2">Nickname already exists in the room.</p>}
                  </Form.Group>
                )}
              </Form>
              {inRoom && (
                <>
                  {!ready && (
                    <Button variant="primary" block className="mt-3" onClick={handleReady}>
                      Ready
                    </Button>
                  )}
                  <ListGroup className="mt-3">
                    {players.map((player, index) => (
                      <ListGroup.Item key={index}>
                        {player.nickname} {player.ready ? "(Ready)" : ""}
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                </>
              )}
            </Card.Body>
                    </Card >
*/
